import { render, staticRenderFns } from "./DoneProjectsControl.vue?vue&type=template&id=36db0283&"
import script from "./DoneProjectsControl.vue?vue&type=script&lang=js&"
export * from "./DoneProjectsControl.vue?vue&type=script&lang=js&"
import style0 from "./DoneProjectsControl.vue?vue&type=style&index=0&id=36db0283&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports